<div class="flex flex-col py-8 justify-center items-center" style="overflow: hidden;">
  <div class="container-padding max-w-screen-desktop mx-auto w-full">
    <div class="flex justify-center items-center">
      <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)] w-full max-w-[600px]">
        <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">
          {{ 'verifyEmail.title' | translate }}
        </h2>
        <div class="w-full border-t border-dotted mb-6 mt-2"></div>

        <div *ngIf="isLoading" class="flex justify-center items-center py-12">
          <div class="spinner"></div>
        </div>

        <div *ngIf="(!isLoading && verificationSucces)">
          <p class="mt-6 font-normal text-[14px]/[14px]">{{ 'verifyEmail.success' | translate }}</p>
          <div class="mt-12 flex justify-center p-3">
            <a routerLink="/login" class="uppercase font-bold text-[var(--black)] text-[14px]/[14px]">
              {{ 'verifyEmail.login' | translate }}
            </a>
          </div>
        </div>

        <div *ngIf="(!isLoading && needsPassword)">
          <div class="flex flex-col items-center text-center gap-4 py-4">
            <div class="text-4xl">✅</div>
            <p class="font-semibold text-[16px]/[22px] text-[var(--black)]">
              ¡Has verificado tu cuenta exitosamente!
            </p>
            <p class="text-[14px]/[20px] text-[var(--dark-grey)]">
              Por favor, hacé clic en continuar para establecer tu contraseña.
            </p>
            <div class="mt-4 w-full">
              <app-button [function]="goToSetPassword.bind(this)" text="Continuar" [fullWidth]="true"></app-button>
            </div>
          </div>
        </div>

        <div *ngIf="(!isLoading && !verificationSucces && !needsPassword)">
          <p class="mt-6 font-normal text-[14px]/[14px]">{{ 'verifyEmail.error' | translate }}</p>
          <div class="mt-12 flex justify-center p-3">
            <a routerLink="/resend-verification-email" class="uppercase font-bold text-[var(--black)] text-[14px]/[14px]">
              {{ 'verifyEmail.resend' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
